"use strict";
exports.__esModule = true;
exports.WITHDRAW_FUNDS = void 0;
exports.WITHDRAW_FUNDS = {
    WITHDRAW_FUNDS_SUCCESS_MODAL: {
        HEADER: 'All set! Your withdrawal is in progress',
        MAIN_TEXT: '${{withdrawalAmount}} will be returned to your debit card ending in {{lastFourDigits}}. We’ll email you once we’ve finished processing the withdrawal.',
        WITHDRAWAL_DISCLAIMER: 'Allow 3-5 business days for the funds to appear in your account.',
        CTA: 'Done'
    },
    MUST_BE_GREATER_THAN_MINIMUM_AMOUNT: 'Must be $0.50 or higher'
};
